import { index } from "./components/index";
import { getNumberLines } from "./components/getNumberLines";

index();




window.addEventListener('load', (event) => {
	if (document.querySelector(".p-home_blog")) {
		setTimeout(() => {
			const $blogtitle = document.querySelectorAll(".p-home_blog h3");
			const $blogbody = document.querySelectorAll(".p-home_blog p");

			for (let i = 0; i < $blogtitle.length; i++) {
				const num = 5 - getNumberLines($blogtitle[i]);
				$blogbody[i].style.setProperty('--clamp', num);
				// alert(getNumberLines($blogtitle[i]));
			}
			// console.log('ページが完全に読み込まれました');
		}, 1000);
	}
	if (document.querySelector(".p-column_list")) {
		setTimeout(() => {
			const $blogtitle = document.querySelectorAll(".p-column_list h3");
			const $blogbody = document.querySelectorAll(".p-column_list p");

			for (let i = 0; i < $blogtitle.length; i++) {
				const num = 5 - getNumberLines($blogtitle[i]);
				$blogbody[i].style.setProperty('--clamp', num);
				// alert(getNumberLines($blogtitle[i]));
			}
			// console.log('ページが完全に読み込まれました');
		}, 1000);
	}
});



window.addEventListener('scroll', function () {
	const mv = document.querySelector('.p-home_mv');
	const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	const header = document.querySelector('.header_logo');
	const footerFixed = document.querySelector('.footer_fixed');
	const footerFixedBg = document.querySelector('.footer_fixed_bg');
	if (mv) {
		if (window.scrollY > (mv.offsetHeight / 1.5)) {
			header.classList.add('_active');
		} else {
			header.classList.remove('_active');
		}
		if (window.scrollY > (mv.offsetHeight / 2)) {
			footerFixed.classList.add('_active');
			footerFixedBg.classList.add('_active');
		} else {
			footerFixed.classList.remove('_active');
			footerFixedBg.classList.remove('_active');
		}
	} else {
		if (window.scrollY > (windowHeight / 1.5)) {
			header.classList.add('_active');
		} else {
			header.classList.remove('_active');
		}
		if (window.scrollY > (windowHeight / 2)) {
			footerFixed.classList.add('_active');
			footerFixedBg.classList.add('_active');
		} else {
			footerFixed.classList.remove('_active');
			footerFixedBg.classList.remove('_active');
		}
	}
});




const spnav = document.querySelector('.nav_sp');
const hamburger = document.querySelector('.hamburger');

hamburger.addEventListener('click', function (e) {
	e.preventDefault();
	hamburger.classList.toggle('_active');
	spnav.classList.toggle('_active');
})

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++) {
	smoothScrollTrigger[i].addEventListener('click', (e) => {
		e.preventDefault();
		let href = smoothScrollTrigger[i].getAttribute('href');
		let targetElement = document.getElementById(href.replace('#', ''));
		const rect = targetElement.getBoundingClientRect().top;
		const offset = window.pageYOffset;
		let gap = 80;
		const target = rect + offset - gap;
		hamburger.classList.remove('_active');
		spnav.classList.remove('_active');
		window.scrollTo({
			top: target,
			behavior: 'smooth',
		});
	});
}

const fixedMenu = document.querySelector('.footer_fixed');
const footer = document.querySelector('.footer');
var footerHeight = footer.offsetHeight + 100;

window.addEventListener('scroll', function () {
	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	var documentHeight = Math.max(
		document.body.scrollHeight,
		document.documentElement.scrollHeight,
		document.body.offsetHeight,
		document.documentElement.offsetHeight,
		document.body.clientHeight,
		document.documentElement.clientHeight
	);
	console.log(window.innerWidth);
	if (window.innerWidth >= 640) {
		if (scrollTop + windowHeight > documentHeight - footerHeight) {
			fixedMenu.style.bottom = footerHeight - (documentHeight - (scrollTop + windowHeight)) + 'px';
		} else {
			fixedMenu.style.bottom = "35px";
		}
	} else {

		if (scrollTop + windowHeight > documentHeight - footerHeight) {
			// document.querySelector('.footer_fixed div').classList.add('_none');
		} else {
			// document.querySelector('.footer_fixed div').classList.remove('_none');
		}
	}
});
